import { ColumnHelper } from '@tanstack/react-table';
import { Checkbox, Container, IconName, Position, Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { TooltippedIcon } from '@mews-commander/ui';
import { CheckInColumnName } from '../types';
import { VisibilityAction } from './VisibilityAction';
import { TableDataItem } from './types';

interface VisibilityCheckboxColumnOptions {
    columnHelper: ColumnHelper<TableDataItem>;
    columnName: Exclude<CheckInColumnName, 'reservationOwner'>;
    isChecked: boolean;
    setChecked: (checked: boolean) => void;
}

export const createVisibilityCheckboxColumn = ({
    columnHelper,
    setChecked,
    isChecked,
    columnName,
}: VisibilityCheckboxColumnOptions) =>
    columnHelper.accessor(`visibility.${columnName}`, {
        header: () => (
            <Container width="100%" padding={['0', '100']}>
                <Stack itemAlignment="center" spacing="100" distribution="space-between">
                    <Checkbox checked={isChecked} onChange={() => setChecked(!isChecked)} id={`${columnName}-checkbox`}>
                        <Typography textStyle="bodyMediumStrong" as="span">
                            {lt(
                                columnName === 'reservationAdult'
                                    ? 'CheckInFieldReservationAdultNameColumnHeader'
                                    : 'CheckInFieldReservationChildNameColumnHeader'
                            )}
                        </Typography>
                    </Checkbox>
                    <TooltippedIcon
                        size="small"
                        tooltipPosition={Position.Top}
                        iconVariant="basic"
                        value={IconName.Info}
                        tooltip={lt('CheckInFieldColumnCheckboxTooltip')}
                    />
                </Stack>
            </Container>
        ),
        id: columnName,
        cell: (props) => <VisibilityAction {...props} columnName={columnName} isChecked={isChecked} />,
        enableSorting: false,
    });
